export class AllMetrics {
	requests:number[] = [];
	pdfs:number[] = [];
	socketConnections:number[] = [];
	runnningJobs:number[] = [];
	queuedJobs:number[] = [];
	interval:number = 0;

	constructor(data?:any) {
		if (!data) return;
		this.requests = data.Requests;
		this.interval = data.Interval;
		this.pdfs = data.Pdfs;
		this.runnningJobs = data.RunningJobs;
		this.queuedJobs = data.QueuedJobs;
		this.socketConnections = data.SocketConnections;
	}
}